import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
const toISO = d => d && d.isValid() ? d.format('YYYY-MM-DD') : null;

/**
 * CIN-7073: a clearable calendar-date picker for a task's due date.
 *
 * Value in and out is a plain 'YYYY-MM-DD' string or null — a due date is a
 * calendar day, not a timestamp, so nothing here ever converts timezones.
 *
 * Why the local state: MUI X reports an INVALID date while the user is still
 * typing ("10/1/2"). Passing that up as null would make the parent hand back
 * null and wipe the half-typed input, so the field keeps its own value and only
 * reports complete dates (or an explicit clear) to the parent.
 */
export const DueDateField = ({
  value = null,
  onChange,
  label = 'Due date',
  disabled = false,
  helperText
}) => {
  const [inner, setInner] = useState(value ? dayjs(value) : null);
  useEffect(() => {
    // Follow the parent (e.g. a save re-sync) unless the user is mid-edit.
    if (inner && !inner.isValid()) return;
    if ((value || null) !== toISO(inner)) setInner(value ? dayjs(value) : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker label={label} value={inner} disabled={disabled} onChange={next => {
      setInner(next);
      if (!next) onChange(null);else if (next.isValid()) onChange(toISO(next));
    }} slotProps={{
      field: {
        clearable: true
      },
      textField: {
        fullWidth: true,
        helperText,
        inputProps: {
          'data-testid': 'task-due-date-input'
        },
        sx: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '14px'
          }
        }
      }
    }} />
    </LocalizationProvider>;
};